export const WORDS = [
  'conan',
  'route',
  'nancy',
  'sunny',
  'takei',
  'gomes',
  'pedro',
  'gerry',
  'party',
  'bundy',
  'saget',
  'welly',
  'gasia',
  'kevin',
  'vinyl',
  'draft',
  'brady',
  'trump',
  'onion',
  'dolly',
  'bless',
  'pixar',
  'lukes',
  'funke',
  'sully',
  'wings',
  'moron',
  'swift',
  'sheik',
  'moose',
  'ortiz',
  'cutty',
  'penis',
  'bryan',
  'dicek',
  'whiff',
  'mmbop',
  'crows',
  'grace',
  'fandf',
  'puppy',
  'gronk',
  'lefty',
  'biden',
  'bette',
  'stern',
  'rider',
  'homer',
  'damon',
  'bruce',
  'nomah',
  'peter',
  'china',
  'prank',
  'jetta',
  'beard',
  'ucant',
  'drain',
  'cards',
  'yanni',
  'candl',
  'hoops',
  'apple',
  'kells',
  'santa',
  'roast',
  'bronx',
  'gourd',
]
